<template>
  <div>
    <PersonalCreate :createPath='createPath' :editPath='editPath'>
    </PersonalCreate>
  </div>
</template>

<script>
import PersonalCreate from '../components/PersonalCreate'

export default {
  components: {
    PersonalCreate
  },
  data () {
    return {
      createPath: 'player/new',
      editPath: `player/${this.$route.params.id}/${this.$route.params.idClub}`
    }
  }
}
</script>
